export const environment = {
  name: '開発環境',
  production: false
};

export const API_URL = 'http://reserve.joyfit.townsystem.co.jp/ems_api';

export const AWS = {
  displayMode: 'ログインセクション (Development Mode)',
  // REQUIRED - Amazon Cognito Identity Pool ID
  identityPoolId: 'ap-southeast-2:65a3ead4-c573-4cd0-9db4-622f208cd827', 
  // REQUIRED - Amazon Cognito Region
  region: 'ap-southeast-2', 
  // OPTIONAL - Amazon Cognito User Pool ID
  userPoolId: 'ap-southeast-2_xaDGbfmLG',
  // OPTIONAL - Amazon Cognito Web Client ID
  userPoolWebClientId: '5piej7tg3ik3i52kstuccrfqu8', 
  // AWS endpoint name
  endPointName: 'AmplifyTest',
  // AWS endpoint
  endPoint: 'https://dh83oi26f4.execute-api.ap-southeast-2.amazonaws.com/Prod',
  /** 強制ログアウトカウントダウンが開始されるまでの無操作時間(秒) */
  timeoutSeconds: 9 * 60 + 30,
  /** 強制ログアウトカウントダウン時間(秒) */
  countdownSeconds: 30,
};

export const IPAD_URL = 'https://ipadtest.wf-datahub.com/entry';

export const URLS = {
  TRIAL_URL : 'https://reserve.wf-test.com/joyfit-ems-trial-test/',
  SEC_URL : 'https://reserve.joyfit.townsystem.co.jp/ptrainer.town/login_other.jsp',
  THIRD_URL : 'https://reserve.joyfit.townsystem.co.jp/web_reservation.town/login_other.na',
  FOUR_URL : 'https://reserve.wf-test.com/ems_mypage_test/#/login-other',
  FIVE_ONE_URL : 'https://entry.joyfit.townsystem.co.jp/companion.',
  FIVE_TWO_URL : '.town/login_other.jsp',
  SIX_URL : 'https://entry.joyfit.townsystem.co.jp/credit_change/login_other.jsp',
  SEVEN_URL: 'http://test-qtform.joyfit-service.jp/web/index.na'
}



// WEBPACK FOOTER //
// ./src/environments/environment.ts